import { Component, EventEmitter, Input, Output } from '@angular/core';

import { List, ListItem, ListProperty, StyleVariants } from '@site-mate/dashpivot-shared-library';

import { ListItemPropertyMap } from '../list-item-property-map.type';

@Component({
  selector: 'cc-list-row',
  templateUrl: './list-row.component.html',
  styleUrls: ['./list-row.component.scss'],
})
export class ListRowComponent {
  @Input() item: ListItem;
  @Input() list: List;
  @Input() itemPropertyTypes: ListItemPropertyMap;
  @Input() isDeployedList: boolean;
  @Input() isExpanded: boolean;
  @Input() isSelected: boolean;
  @Input() folder: any;
  @Input() parentId: string;
  @Input() beforeAddPropertyIterator: Array<void>;
  @Input() afterAddPropertyIterator: Array<void>;
  @Input() addPropertyIndex: number;
  @Input() canEditProperties: boolean;

  @Output() toggleRowSelect = new EventEmitter<string>();
  @Output() toggleRowExpand = new EventEmitter<void>();
  @Output() setEditMode = new EventEmitter<boolean>();
  @Output() itemPropertyInteracted = new EventEmitter<ListProperty>();
  @Output() itemEdited = new EventEmitter<ListItem>();
  @Output() itemEditCancelled = new EventEmitter<string>();
  @Output() itemStyleUpdated = new EventEmitter<StyleVariants>();
  @Output() listCellUpdated = new EventEmitter<{ value: Record<string, any>; index: number }>();
  @Output() listDeployed = new EventEmitter<List>();

  readonly styleVariants = StyleVariants;

  toggleSelection() {
    this.toggleRowSelect.emit();
  }

  toggleExpand() {
    this.toggleRowExpand.emit();
  }

  editItem(event: ListItem) {
    this.itemEdited.emit(event);
  }

  onSetEditMode(event: boolean) {
    this.setEditMode.emit(event);
  }

  onListDeployed(event: List) {
    this.listDeployed.emit(event);
  }

  cancelEdit() {
    this.itemEditCancelled.emit();
  }

  onStyleUpdated(newStyle: StyleVariants) {
    this.itemStyleUpdated.emit(newStyle);
  }

  updateCell(event: Record<string, any>, index: number) {
    this.listCellUpdated.emit({ value: event.value, index });
  }

  onInteract(propertyHeader: ListProperty) {
    this.itemPropertyInteracted.emit(propertyHeader);
  }

  trackItemById(_index: number, item: ListItem): string {
    return item._id;
  }

  trackByBeforeAddPropertyColumn(index: number) {
    return this.list.properties[index];
  }

  trackByAfterAddPropertyColumn(index: number) {
    return this.list.properties ? this.list.properties[index + (this.addPropertyIndex || 0)] : null;
  }
}
